import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodGooglePayDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4134_566)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
				fill: "url(#paint0_linear_4134_566)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 0.25H44C46.0711 0.25 47.75 1.92893 47.75 4V28C47.75 30.0711 46.0711 31.75 44 31.75H4C1.92893 31.75 0.25 30.0711 0.25 28V4C0.25 1.92893 1.92893 0.25 4 0.25Z",
				stroke: "white",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_4134_566)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M23.01 16.8652V21.0502H21.66V10.7002H25.17C26.025 10.7002 26.835 11.0152 27.465 11.6002C28.095 12.1402 28.41 12.9502 28.41 13.8052C28.41 14.6602 28.095 15.4252 27.465 16.0102C26.835 16.5952 26.07 16.9102 25.17 16.9102L23.01 16.8652ZM23.01 11.9602V15.5602H25.26C25.755 15.5602 26.25 15.3802 26.565 15.0202C27.285 14.3452 27.285 13.2202 26.61 12.5452L26.565 12.5002C26.205 12.1402 25.755 11.9152 25.26 11.9602H23.01Z",
						fill: "#5F6368"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M31.515 13.7603C32.505 13.7603 33.27 14.0303 33.855 14.5703C34.44 15.1103 34.71 15.8303 34.71 16.7303V21.0503H33.45V20.0603H33.405C32.865 20.8703 32.1 21.2753 31.2 21.2753C30.435 21.2753 29.76 21.0503 29.22 20.6003C28.725 20.1503 28.41 19.5203 28.41 18.8453C28.41 18.1253 28.68 17.5403 29.22 17.0903C29.76 16.6403 30.525 16.4603 31.425 16.4603C32.235 16.4603 32.865 16.5953 33.36 16.9103V16.5953C33.36 16.1453 33.18 15.6953 32.82 15.4253C32.46 15.1103 32.01 14.9303 31.515 14.9303C30.75 14.9303 30.165 15.2453 29.76 15.8753L28.59 15.1553C29.31 14.2103 30.255 13.7603 31.515 13.7603ZM29.805 18.8903C29.805 19.2503 29.985 19.5653 30.255 19.7453C30.57 19.9703 30.93 20.1053 31.29 20.1053C31.83 20.1053 32.37 19.8803 32.775 19.4753C33.225 19.0703 33.45 18.5753 33.45 18.0353C33.045 17.7203 32.46 17.5403 31.695 17.5403C31.155 17.5403 30.705 17.6753 30.345 17.9453C29.985 18.1703 29.805 18.4853 29.805 18.8903Z",
						fill: "#5F6368"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M42 13.9854L37.545 24.2004H36.195L37.86 20.6454L34.935 14.0304H36.375L38.49 19.1154H38.535L40.605 14.0304H42V13.9854Z",
						fill: "#5F6368"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M17.655 15.965C17.655 15.56 17.61 15.155 17.565 14.75H11.94V17.045H15.135C15 17.765 14.595 18.44 13.965 18.845V20.33H15.9C17.025 19.295 17.655 17.765 17.655 15.965Z",
						fill: "#4285F4"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M11.94 21.7701C13.56 21.7701 14.91 21.2301 15.9 20.3301L13.965 18.8451C13.425 19.2051 12.75 19.4301 11.94 19.4301C10.41 19.4301 9.06 18.3951 8.61001 16.9551H6.63V18.4851C7.665 20.5101 9.69001 21.7701 11.94 21.7701Z",
						fill: "#34A853"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M8.60999 16.9551C8.33999 16.2351 8.33999 15.4251 8.60999 14.6601V13.1301H6.62999C5.77499 14.7951 5.77499 16.7751 6.62999 18.4851L8.60999 16.9551Z",
						fill: "#FBBC04"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M11.94 12.2301C12.795 12.2301 13.605 12.5451 14.235 13.1301L15.945 11.4201C14.865 10.4301 13.425 9.84512 11.985 9.89012C9.73499 9.89012 7.66499 11.1501 6.67499 13.1751L8.65499 14.7051C9.05999 13.2651 10.41 12.2301 11.94 12.2301Z",
						fill: "#EA4335"
					})
				]
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4134_566",
			x1: 0,
			y1: 0,
			x2: 48,
			y2: 32,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "white",
				stopOpacity: .04
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white",
				stopOpacity: .16
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4134_566",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 32,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_4134_566",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 17.145,
				fill: "white",
				transform: "translate(6 8)"
			})
		})
	] })]
});
export default SvgPaymentMethodGooglePayDark;
